import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";

export const LANGUAGES = [
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
  { code: "en", label: "EN", name: "English", flag: "🇺🇸" },
  { code: "pt", label: "PT", name: "Português", flag: "🇧🇷" },
  { code: "fr", label: "FR", name: "Français", flag: "🇫🇷" },
  { code: "de", label: "DE", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "IT", name: "Italiano", flag: "🇮🇹" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en", "pt", "fr", "de", "it"],
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      // Orden: 1) lo que el usuario eligió antes (localStorage),
      // 2) idioma del navegador (navigator.language → ES, EN, PT, etc.),
      // 3) etiqueta html (server-side hint), 4) fallback español.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "cia_lang",
      caches: ["localStorage"],
    },
  });

// Si el usuario nunca ha elegido idioma, intentamos refinar usando
// /api/geo (Cloudflare cf-ipcountry). Esto sobrescribe la detección por
// navigator solo cuando aún no hay preferencia guardada.
if (typeof window !== "undefined") {
  const saved = window.localStorage.getItem("cia_lang");
  if (!saved) {
    const apiBase = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${apiBase}/api/geo`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const next = data?.lang;
        if (next && i18n.language?.slice(0, 2) !== next) {
          i18n.changeLanguage(next);
        }
      })
      .catch(() => {
        /* ignore — ya tenemos default por navigator */
      });
  }
}

export default i18n;
